import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";
import { applyPageSeo } from "@/lib/seo";

/** Updates document title + meta tags from CMS settings for the current route. */
const PageSeo = ({ pageKey, title, description, path, image }) => {
    const { settings, pages } = useSettings();
    const location = useLocation();

    useEffect(() => {
        if (!settings) return;
        applyPageSeo({
            settings,
            pages,
            pageKey,
            title,
            description,
            path: path ?? location.pathname,
            image,
        });
    }, [settings, pages, pageKey, title, description, path, image, location.pathname]);

    return null;
};

export default PageSeo;
